import { useRef, useState } from "react";
import { toast } from "sonner";
import { UploadCloud, Loader2 } from "lucide-react";
import api from "@/lib/api";

export default function FileUploader({ onUploaded, accept = ".pdf,.png,.jpg,.jpeg,.webp,.doc,.docx,.xls,.xlsx,.csv,.txt", label = "Arrossega o clica per pujar" }) {
  const inputRef = useRef();
  const [dragging, setDragging] = useState(false);
  const [uploading, setUploading] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onUploaded && onUploaded(data);
      toast.success("Fitxer pujat");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Error pujant el fitxer");
    } finally { setUploading(false); }
  };

  return (
    <div
      onDragOver={(e) => { e.preventDefault(); setDragging(true); }}
      onDragLeave={() => setDragging(false)}
      onDrop={(e) => { e.preventDefault(); setDragging(false); upload(e.dataTransfer.files?.[0]); }}
      onClick={() => inputRef.current?.click()}
      className={`rounded-2xl border-2 border-dashed p-8 text-center cursor-pointer transition-colors duration-200 ${dragging ? "border-accent bg-accent/5" : "border-border hover:border-accent"}`}
      data-testid="file-uploader"
    >
      <input ref={inputRef} type="file" accept={accept} className="hidden" onChange={(e) => upload(e.target.files?.[0])} data-testid="file-uploader-input" />
      {uploading ? (
        <div className="flex flex-col items-center gap-2 text-sm text-muted-foreground">
          <Loader2 className="w-6 h-6 animate-spin" /> Pujant...
        </div>
      ) : (
        <div className="flex flex-col items-center gap-2">
          <UploadCloud className="w-8 h-8 text-accent" />
          <div className="text-sm font-medium">{label}</div>
          <div className="text-xs text-muted-foreground">PDF, imatges, Word, Excel, CSV — màx 15 MB</div>
        </div>
      )}
    </div>
  );
}
